<template>
  <div class="sort-manage">
    <second-menu-link-content>
      <template v-slot:header>
        <span>商品分类</span>
      </template>
      <template v-slot:content>
        <div class="sort-manage-main">
          <div class="add-sort">
            <el-button class="btn-blue" @click="dialogVisible=true">新增分类</el-button>
            <el-dialog title="新增分类" :visible.sync="dialogVisible" width="400px" top="25vh">
              <!-- 黑色的线条 -->
              <div class="border"></div>
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
              >
                <el-form-item label="新增分类：" prop="sort">
                  <el-input v-model="ruleForm.sort" class="gray" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button class="btn-white" type="primary" @click="reset('ruleForm')">取消</el-button>
                  <el-button class="btn-blue" @click="addSort('ruleForm')">保存</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
          </div>
          <div class="sort-list">
            <div class="title">
              <span>分类</span>
              <span class="right-title">
                <span>是否对用户可见</span>
                <span>操作</span>
              </span>
            </div>
            <div class="subtitle">
              <span style="padding-left: 30px;">系统分类</span>
              <span class="color">系统预设不可修改</span>
            </div>
            <div class="lists">
              <el-tree
                draggable
                :allow-drop="allowDrop"
                @node-drop="sort"
                :data="datas"
                :props="defaultProps"
                node-key="id"
                @node-click="handleNodeClick"
                :render-content="renderContent"
                auto-expand-parent
                :expand-on-click-node="false"
              ></el-tree>
            </div>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import DBCommodity from "models/db/commodity.js";
const dbCommodity = new DBCommodity();
export default {
  components: {
    SecondMenuLinkContent,
  },
  data() {
    return {
      ruleForm: {
        sort: "",
      },
      ruleForm2: {
        sort: "",
        index: 0,
      },
      rules: {
        sort: [{ required: true, message: "请输入类名", trigger: "blur" }],
      },
      datas: [],
      defaultProps: {
        children: "children",
        label: "cateName",
      },
      dialogVisible: false,
      dialogVisible2: false,
    };
  },
  beforeMount() {
    this.getGoodsClassify();
  },
  methods: {
    // 获取分类列表
    getGoodsClassify() {
      dbCommodity.getDBGoodsClassify().then((res) => {
        if (res.success) {
          this.datas = []
          res.result.map(i => {
            if (i.cateName != '系统分类') {
              this.datas.push(i);
            }
          })
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 取消
    reset(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    // 添加分类
    addSort(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let cateName = this.ruleForm.sort;
          let parentId = null;
          dbCommodity.postDBAddGoodsClassify(cateName, parentId).then((res) => {
            if (res.success) {
              let obj = {};
              obj.cateName = cateName;
              obj.id = res.result.id;
              obj.children = [];
              this.datas.push(obj);
            } else {
              this.$message.error(res.message);
            }
          });
          this.$refs[formName].resetFields();
          this.dialogVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleNodeClick(data) {},
    // 新增
    append(node, data) {
      this.$prompt("", "新增子类", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S{1,}/,
        inputErrorMessage: "不能为空！",
      }).then(({ value }) => {
        if (!node.parent.label && node.childNodes.length === 8) {
          this.$message.error("二级分类最多8个");
        } else {
          let cateName = value;
          let parentId = data.id;
          dbCommodity.postDBAddGoodsClassify(cateName, parentId).then((res) => {
            if (res.success) {
              // this.getGoodsClassify();
              const newChild = {
                id: res.result.id,
                cateName: cateName,
                children: [],
              };
              if (!data.children) {
                this.$set(data, "children", []);
              }
              data.children.push(newChild);
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    // 删除
    remove(node, data) {
      this.$confirm(`是否确认删除该分类`, "删除分类", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let id = data.id;
        dbCommodity.postDBDeleteGoodsClassify(id).then((res) => {
          if (res.success) {
            const parent = node.parent;
            const children = parent.data.children || parent.data;
            const index = children.findIndex((d) => d.id === data.id);
            children.splice(index, 1);
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    // 修改
    change(node, data) {
      this.$prompt("", "修改子类", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S{1,}/,
        inputPlaceholder: data.cateName,
        inputErrorMessage: "不能为空！",
      }).then(({ value }) => {
        let cateName = value;
        let id = data.id;
        dbCommodity.postDBUpdateGoodsClassify(id, cateName).then((res) => {
          if (res.success) {
            this.$set(data, "cateName", value);
            // this.getGoodsClassify();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    // 游客是否可见
    changeTourists(node, data) {
      let visitorVisibleSwitch = data.visitorVisibleFlag?1:0
      let id = data.id
      let obj = {
        visitorVisibleSwitch,
        id
      }
      dbCommodity.postChangeTourists(obj).then(res => {
        if (res.success) {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.getGoodsClassify()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    renderContent(h, { node, data, store }) {
      return (
        <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
          <span>
            <span>{node.label}</span>
          </span>
          <span class="right">
            <span class="tourists">
              <el-switch
                style="display: block"
                on-change={() => this.changeTourists(node, data)}
                disabled={!data.operateFlag}
                v-model={data.visitorVisibleFlag}
              ></el-switch>
            </span>
            <span>
              <el-button
                style="font-size: 14px;margin-right: 16px;"
                type="text"
                on-click={() => this.append(node, data)}
                class="addclass"
              >
                新增子类
              </el-button>
              <el-button
                style="font-size: 14px;margin-right: 16px;"
                type="text"
                on-click={() => this.change(node, data)}
              >
                修改
              </el-button>
              <el-button
                style="font-size: 14px;margin-right: 16px;"
                type="text"
                on-click={() => this.remove(node, data)}
              >
                删除
              </el-button>
            </span>
          </span>
        </span>
      );
    },
    //同级拖拽
    allowDrop(draggingNode, dropNode, type) {
      if (draggingNode.data.cateName == '系统分类') {
        return false 
      }
      if (draggingNode.level === dropNode.level) {
        if (draggingNode.parent.id === dropNode.parent.id) {
          // 向上拖拽 || 向下拖拽
          return type === "prev" || type === "next";
        }
      } else {
        // 不同级进行处理
        return false;
      }
    },
    //同级拖拽后的排序
    sort(draggingNode, dropNode) {
      //  拖拽之后的重新组合的数组
      let arr = []
      let obj = {
        parentId: "",
        sourceId: '',
        serial: 0,
      };
      obj.parentId = Number(dropNode.data.parentId);
      obj.sourceId = Number(draggingNode.data.id);
      for (let item of dropNode.parent.childNodes) {
        arr.push(item.data.id);
      }
      arr.map((i,index) => {
        if (obj.sourceId == i) {
          obj.serial = Number(index + 1)
        }
      })
      this.postGoodscateWeight(obj)
    },
    //权重排序
    postGoodscateWeight(data) {
      dbCommodity.postGoodscateWeight(data).then(res => {
        if (res.success) {
          this.getGoodsClassify();
        } else {
          this.$message.error(res.message);
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.sort-manage {
  width: 100%;
  height: 100%;
  .sort-manage-main {
    height: auto;
    .add-sort {
      margin-bottom: 16px;
      .el-button {
        width: 128px;
        letter-spacing: 2px;
      }
    }
  }
}
</style>
<style lang="scss">
.sort-manage {
  .sort-manage-main {
    .add-sort {
      .el-dialog {
        .el-button {
          width: 90px;
        }
      }
    }
    .sort-list {
      font-size: 14px;
      .title {
        height: 32px;
        background: rgba(245, 247, 250, 1);
        border-radius: 8px 8px 0px 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px;
        .right-title {
          width: 300px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
      .subtitle {
        height: 31px;
        border-bottom: 1px solid #f2f6fc;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px;
        font-family: "PingFangSC-Regular";
        .color {
          color: #606266;
        }
      }
      .lists {
        .el-tree {
          .el-tree-node {
            .el-tree-node__content {
              cursor: Default;
              height: 31px;
              border-bottom: 1px solid #f2f6fc;
              .el-icon-caret-right:before {
                content: "";
              }
              .el-tree-node__expand-icon {
                background: url(../../../../assets/images/open.png) center
                  no-repeat;
                margin-left: 24px;
                width: 12px;
                height: 12px;
                -webkit-transform: rotate(0deg);
                transform: rotate(0deg);
              }
              .expanded {
                background: url(../../../../assets/images/close.png) center
                  no-repeat;
                margin-left: 24px;
              }
              .is-leaf {
                background: #fff;
                opacity: 0;
                margin-left: 24px;
              }
              .el-tree-node__label {
                margin-left: 8px;
              }
            }
            .el-tree-node__children {
              .el-tree-node__children {
                .addclass {
                  display: none;
                }
              }
            }
            .el-tree-node__content:hover {
              background-color: #f5f7fa;
            }
            .el-button {
              color: #606266;
            }
            .el-button:hover {
              color: #3d74f2;
            }
          }
          .right {
            width: 300px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          // > .el-tree-node:first-child {
          //   .right {
          //     display: none;
          //   }
          // }
          // > .el-tree-node:first-child {
          //   position: relative;
          //   .right {
          //     display: none;
          //   }
          // }
          // > .el-tree-node:first-child:after {
            // content: "系统预设不可修改";
            // position: absolute;
            // top: 0;
            // right: 25px;
            // line-height: 32px;
          // }
          .el-tree-node:focus > .el-tree-node__content {
            background-color: #fff;
          }
        }
      }
    }
  }
}
</style>
